import DefaultRoute from "/pages/default.vue";
import LoginRoute from "/pages/login.vue";
import LoginPage from "/pages/login/login.vue"
import financeiro from "./financeiro";
import menu from '/pages/menu/index.vue'


const routes = [
    {
        path: "/",
        component: DefaultRoute,
        
        children: [
            {
                path: "menu",
                component: menu
            },
            {
                path: "",
                component: () => import("/pages/home/index.vue"),
                meta: {
                    isMainScreen: true,
                },
            },
            {
                path: "/solicitacao-de-pagamento",
                component: () => import("/pages/solicitacao-de-pagamento/index.vue"),
                meta: {
                    isPublic: true,

                },
                children: [
                    {
                        path: "",
                        alias: "busca-fornecedor",
                        component: () => import("/pages/solicitacao-de-pagamento/busca-fornecedor.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "cadastro-fornecedor",
                        component: () => import("/pages/solicitacao-de-pagamento/cadastro-fornecedor.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "recuperar-senha",
                        component: () => import("/pages/solicitacao-de-pagamento/recuperar-senha.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "alterar-senha",
                        component: () => import("/pages/solicitacao-de-pagamento/alterar-senha.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "busca-condominio",
                        component: () => import("/pages/solicitacao-de-pagamento/busca-condominio.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "cadastro-condominio",
                        component: () => import("/pages/solicitacao-de-pagamento/cadastro-condominio.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "solicitacao",
                        component: () => import("/pages/solicitacao-de-pagamento/solicitacao.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                    {
                        path: "historico",
                        component: () => import("/pages/solicitacao-de-pagamento/historico.vue"),
                        meta: {
                            isPublic: true,
                            isPrivate: true
                        }
                    },
                ]
            },
            {
                path: "/dados-condominos",
                component: () => import("/pages/dados-condominos/index.vue"),

                children: [
                    {
                        path: "",
                        meta: {
                            isMainScreen: true,
                        },
                        component: () => import("/pages/dados-condominos/dados-condominos.vue"),
                    },
                    {
                        path: "lista-condomino",
                        component: () => import("/pages/dados-condominos/lista-condomino/index.vue"),
                        meta: {
                            isMainScreen: true,
                        },

                        children: [
                            {
                                path: '',
                                component: () => import("/pages/dados-condominos/lista-condomino/lista.vue"),
                                meta: {
                                    isMainScreen: true,
                                },
                            }
                        ]
                    },
                    {
                        path: "documentos",
                        component: () => import("/pages/dados-condominos/documentos/index.vue"),
                        meta: {
                            isMainScreen: true,
                        },

                        children: [
                            {
                                path: '',
                                component: () => import("/pages/dados-condominos/documentos/lista.vue"),
                                meta: {
                                    isMainScreen: true,
                                },
                            },
                            {
                                path: 'novo',
                                component: () => import('/pages/dados-condominos/documentos/novo.vue'),
                            },
                            {
                                path: 'editar/:id',
                                component: () => import('/pages/dados-condominos/documentos/editar.vue'),
                            },
                            {
                                path: 'visualizar/:id',
                                component: () => import('/pages/dados-condominos/documentos/visualizar.vue'),
                            }
                        ]
                    },
                    {
                        path: "certidao-negativa",
                        component: () => import("/pages/certidao-negativa/index.vue"),
                        children: [
                            {
                                path: "",
                                name: "solicitacao",
                                alias: "solicitacao",
                                component: () => import("/pages/certidao-negativa/solicitacao.vue")
                            },
                     
                            {
                                path: "status-pagamento-boleto",
                                name: "status-pagamento-boleto",
                                component: () => import("/pages/certidao-negativa/status-pagamento-boleto.vue")
                            },
                            {
                                path: "download-certidao-negativa",
                                name: "download-certidao-negativa",
                                component: () => import("/pages/certidao-negativa/download-certidao-negativa.vue")
                            },
                        ]
                    },
                ],
            },
            {
                path: "/documentos",
                component: () => import("/pages/dados-condominos/documentos/index.vue"),

                children: [
                    {
                        path: '',
                        component: () => import("/pages/dados-condominos/documentos/lista.vue"),
                        meta: {
                            isMainScreen: true,
                        },
                    },
                    {
                        path: 'novo',
                        component: () => import('/pages/dados-condominos/documentos/novo.vue'),
                    },
                    {
                        path: 'editar/:id',
                        component: () => import('/pages/dados-condominos/documentos/editar.vue'),
                    },
                    {
                        path: 'visualizar/:id',
                        component: () => import('/pages/dados-condominos/documentos/visualizar.vue'),
                    }
                ]
            },

            {
                path: "/seguro-conteudo",
                component: () => import("/pages/seguro-conteudo/index.vue"),
                meta: {
                    isMainScreen: true,
                },
            },
            {
                path: "/meus-dados",
                component: () => import("/pages/meus-dados/index.vue"),
                meta: {
                    isMainScreen: true,
                },
            },
            {
                path: "/cadastro-de-dependentes",
                component: () => import("/pages/cadastro-de-dependentes/index.vue"),
                children: [
                    {
                        path: "",
                        component: () => import("/pages/cadastro-de-dependentes/lista.vue"),
                    },
                    {
                        path: "novo",
                        component: () => import("/pages/cadastro-de-dependentes/editar.vue"),
                    },
                    {
                        path: ":id",
                        component: () => import("/pages/cadastro-de-dependentes/editar.vue"),
                    }
                ]
            },
            {
                path: "/prestadores",
                component: () => import("/pages/prestadores/index.vue"),
                meta: {
                    isMainScreen: true,
                },
            },
            
            {
                path: "/reservas",
                component: () => import("/pages/reservas/index.vue"),

                children: [
                    {
                        path: "",
                        meta: {
                            isMainScreen: true,
                        },
                        component: () => import("/pages/reservas/reservas.vue"),
                    },
                    {
                        path: "reservar",
                        component: () => import("/pages/reservas/reservar.vue"),
                        meta: {
                            isMainScreen: true,
                        },
                    },
                    {
                        path: "minhas-reservas",
                        component: () => import("/pages/reservas/minhas-reservas.vue"),
                        meta: {
                            isMainScreen: true,
                        },
                    },
                    {
                        path: "gerenciar-reservas",
                        component: () =>
                            import("/pages/reservas/gerenciar-reservas.vue"),
                    },
                    {
                        path: "datas-bloqueadas",
                        component: () =>
                            import("/pages/reservas/datas-bloqueadas/index.vue"),
                        children: [
                            {
                                path: "editar/:codigo_condominio/:ambiente_id/:id",
                                component: () => import("/pages/reservas/datas-bloqueadas/editar.vue"),
                                props: true
                            }
                        ]
                    },
                    {
                        path: "reservas-canceladas",
                        component: () =>
                            import("/pages/reservas/reservas-canceladas.vue"),
                    },
                    {
                        path: "nova/:ambiente_id/:turno_id/:data",
                        component: () => import("/pages/reservas/nova.vue")
                    },
                    {
                        path: "detalhes/:id",
                        component: () => import("/pages/reservas/detalhes.vue")
                    },
                    {
                        path: "checklist/:id",
                        component: () => import("/pages/reservas/checklist.vue")
                    }
                ],
            },
            {
                path: "/mural",
                component: () => import("/pages/mural/index.vue"),
                children: [
                    {
                        path: "",
                        meta: {
                            isMainScreen: true,
                        },
                        component: () => import("/pages/mural/mural.vue"),
                    },
                    {
                        path: "chama-o-sindico",
                        component: () => import("/pages/mural/chama-o-sindico/index.vue"),
                        children: [
                            {
                                path: '',
                                component: () => import('/pages/mural/chama-o-sindico/lista.vue'),
                                meta: {
                                    isMainScreen: true,
                                },
                            },
                            {
                                path: 'informacoes/:id',
                                component: () => import('/pages/mural/chama-o-sindico/visualizar.vue')
                            },
                            {
                                path: 'novo',
                                component: () => import('/pages/mural/chama-o-sindico/novo.vue')
                            }
                        ]
                    },
                    {
                        path: "quadro-de-avisos",
                        component: () => import("/pages/mural/quadro-de-avisos/index.vue"),
                        children: [
                            {
                                path: '',
                                component: () => import('/pages/mural/quadro-de-avisos/lista.vue'),
                                meta: {
                                    isMainScreen: true,
                                },
                            },
                            {
                                path: 'informacoes/:id',
                                component: () => import('/pages/mural/quadro-de-avisos/informacoes.vue')
                            },
                            {
                                path: "novo",
                                component: () => import('/pages/mural/quadro-de-avisos/novo.vue')
                            }
                        ]
                    },
                    {
                        path: "assembleias",
                        component: () => import("/pages/mural/assembleias.vue"),
                    },
                    {
                        path: "notificacao-portaria",
                        component: () => import('/pages/mural/notificacao-portaria/index.vue'),
                        children: [
                            {
                                path: '',
                                component: () => import('/pages/mural/notificacao-portaria/lista.vue')
                            },
                            {
                                path: 'nova',
                                component: () => import('/pages/mural/notificacao-portaria/nova.vue')
                            },
                            {
                                path: 'visualizar/:id',
                                component: () => import('/pages/mural/notificacao-portaria/visualizar.vue'),
                                props: route => ({
                                    id: route.params.id
                                })
                            }
                        ]
                    },
                    {
                        path: "notificacao-mudanca",
                        component: () =>
                            import("/pages/mural/notificacao-mudanca/index.vue"),
                        children: [
                            {
                                path: "",
                                component: () =>
                                    import(
                                        "/pages/mural/notificacao-mudanca/lista.vue"
                                    ),
                                meta: {
                                    isMainScreen: true,
                                },
                            },
                            {
                                path: "notificar",
                                component: () =>
                                    import(
                                        "/pages/mural/notificacao-mudanca/notificar.vue"
                                    ),
                            },
                            {
                                path: "informacoes/:id",
                                component: () => import('/pages/mural/notificacao-mudanca/informacoes.vue')
                            }
                        ],
                    },
                    {
                        path: "agenda-sindico",
                        component: () =>
                            import("/pages/mural/agenda-sindico/index.vue"),
                        children: [
                            {
                                path: "",
                                component: () =>
                                    import("/pages/mural/agenda-sindico/lista.vue"),
                                meta: {
                                    isMainScreen: true,
                                },
                            },
                            {
                                path: "novo/:data",
                                component: () =>
                                    import("/pages/mural/agenda-sindico/novo.vue"),
                            },
                            {
                                path: "editar/:id",
                                component: () => import('/pages/mural/agenda-sindico/novo.vue'),
                            },
                            {
                                path: "informacoes/:data/:id",
                                component: () =>
                                    import(
                                        "/pages/mural/agenda-sindico/informacoes.vue"
                                    ),
                            },
                        ],
                    },
                ],
            },
            financeiro,
            {
                path: "/administracao-condominio",
                component: () => import('/pages/administracao-condominio/index.vue'),
                children: [
                    {
                        path: 'dados-sindico',
                        component: () => import('/pages/administracao-condominio/dados-sindico/index.vue')
                    }
                ]
            }
        ]
    },
    {
        path: "/login",
        component: LoginRoute,
        children: [
            {
                path: "",
                component: LoginPage,
                meta: {
                    isMainScreen: true,
                    isPublic: true,
                    layout: "Login",
                },
            },
            {
                path: "esqueci-minha-senha",
                component: () => import("/pages/login/esqueci-minha-senha.vue"),
                meta: {
                    isPublic: true,
                    layout: "Login",
                },
            },
            {
                path: "primeiro-acesso",
                component: () => import("/pages/login/primeiro-acesso.vue"),
                meta: {
                    isPublic: true,
                    layout: "Login",
                },
            },
            {
                path: "alterar-senha",
                component: () => import("/pages/login/alterar-senha.vue"),
                meta: {
                    isPublic: true,
                    layout: "Login",
                },
            },
        ],
    },
    
];

export default routes;
